import exitWhite from "../../assets/exit-white.svg";

const ModifyIntakeItem = (props) => {
  const { item, handleDelete } = props;
  const nutrients = ["calories", "fat", "protein", "carbs"];

  return (
    <li className="modify-intake__todays-intake-item">
      <div className="modify-intake__todays-intake-item-content-left">
        <p className="modify-intake__todays-intake-item-title">{item.name}</p>
        <div className="modify-intake__todays-intake-item-nutrition">
          {nutrients.map((nutrient, index) => (
            <div className="modify-intake__todays-intake-item-nutrient" key={index}>
              <p className="modify-intake__todays-intake-item-nutrient-title">{nutrient}</p>
              <p className="modify-intake__todays-intake-item-nutrient-amount">
                {item[nutrient]}
                {nutrient === "calories" ? "cal" : "g"}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="modify-intake__todays-intake-item-content-right">
        <p className="modify-intake__todays-intake-item-amount">
          {item.amount}
          {item.amountUnit}
        </p>
        <img
          src={exitWhite}
          className="modify-intake__todays-intake-item-delete"
          alt="delete"
          onClick={() => {
            handleDelete(item.id);
          }}
        />
      </div>
    </li>
  );
};

export default ModifyIntakeItem;
